import * as React from 'react';
import { FormattedNumber } from 'dibs-react-intl';
import { priceVariabilityLabel } from './messages';

// Styles
import styles from './styles.scss';

type PriceLabelProps = {
    currency: string;
    label?: React.ReactNode;
    price: number;
    quantityDisplay?: string | null;
    showPriceVariability?: boolean | null;
};

export const PriceLabel: React.FC<PriceLabelProps> = ({
    price,
    label,
    quantityDisplay,
    currency,
    showPriceVariability,
}) => {
    const priceIntl = (
        <FormattedNumber
            value={price}
            currency={currency}
            style="currency"
            minimumFractionDigits={0}
            maximumFractionDigits={0}
        />
    );

    return (
        <div className={styles.priceLabel} data-tn="price">
            {showPriceVariability && priceVariabilityLabel}
            {showPriceVariability ? ' ' : ''}
            {priceIntl}
            {label ? ' ' : ''}
            {label}
            {quantityDisplay ? ' ' : ''}
            {quantityDisplay}
        </div>
    );
};

PriceLabel.defaultProps = {
    showPriceVariability: false,
};
